<template>
  <div class="agent-service-translation-switch">
    <button type="button" :class="{ 'is-selected': translationMode === 'single' }"
      :aria-pressed="translationMode === 'single'"
      :title="modeLabel" :aria-label="`${modeLabel}，${$t('agentServiceUI.toggleTranslationMode')}`"
      @click="toggleTranslationMode">
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">
        <path d="M3 5h12M9 3v2m4 0c-1 6-4 9-9 11m2-8c1 3 3 5 6 7M13 21l4-11 4 11m-6.5-4h5"
          stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </button>
  </div>
</template>

<script>
/** 三个Agent及消息中心共用展示开关；选中为单语，不选中为双语，不修改会话语种或触发重译。 */
export default {
  name: "AgentServiceTranslationSwitch",
  props: { translationMode: { type: String, default: "bilingual" } },
  computed: {
    modeLabel() {
      return this.$t(this.translationMode === "single" ? "agentServiceUI.singleMode" : "agentServiceUI.bilingualMode");
    },
  },
  methods: {
    /** 只通知父级更新本地展示偏好；保持原文、翻译快照和模型任务不变。 */
    toggleTranslationMode() {
      this.$emit("update:translation-mode", this.translationMode === "single" ? "bilingual" : "single");
    },
  },
};
</script>

<style lang="less" scoped>
.agent-service-translation-switch {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;

  button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    min-width: 44px;
    height: 44px;
    padding: 0;
    border: 0;
    background: transparent;
    color: var(--m-text-secondary, #667085);
    cursor: pointer;
    transition: color 160ms ease;

    svg {
      width: 22px;
      height: 22px;
      filter: drop-shadow(0 1px 1px rgba(15, 23, 42, .16));
    }
    &.is-selected { color: var(--m-brand-600, #246de0); }
    &:focus-visible { outline: 2px solid #4286f5; outline-offset: -2px; border-radius: 8px; }
    @media (prefers-reduced-motion: reduce) { transition: none; }
  }
}
</style>
